// Add your custom JS here.
import {hero} from "./modules/hero/hero";
import {tabs} from './modules/helpers/tabs'
import {accordion} from "./modules/helpers/accordion";
import {contactForm} from "./modules/forms/contact-form";
import {playVideo} from "./modules/helpers/play-video";
import {reviews} from "./modules/blocks/reviews";
import {postVideo} from "./modules/singles/post-video";
import {header} from "./modules/header/header";
import {customSelect} from "./modules/helpers/custom-select";
import {GatedContentForm} from "./modules/forms/gated-content-form";
import {servicesFaq} from "./modules/blocks/services-faq";
import {popupVideo} from "./modules/helpers/popup-video";

document.addEventListener("DOMContentLoaded", function (event) {

    const solutionsButtons = document.querySelectorAll('.solutions-tabs__left-item');
    const solutionsTabs = document.querySelectorAll('.solutions-tabs__right-item');

    const servicesFaqBtns = document.querySelectorAll('.services-faq__item-top');
    const servicesFaqCont = document.querySelectorAll('.services-faq__item-bottom');
    const servicesFaqItems = document.querySelectorAll('.services-faq__item');

    const faqBlockBtns = document.querySelectorAll('.faq-block__item-question');
    const faqBlockCont = document.querySelectorAll('.faq-block__item-answer');
    const faqBlockItems = document.querySelectorAll('.faq-block__item');

    const careersButtons = document.querySelectorAll('.careers-tabs__button');
    const careersTabs = document.querySelectorAll('.careers-tabs__item');

    const heroPlayBtn = document.querySelector('.hero__play');
    const heroVideo = document.querySelector('.hero-video');

    // const byNumbersPlayBtn = document.querySelector('.by-numbers__play');
    // const byNumbersVideo = document.querySelector('.by-numbers__video video');



    const mobileLink = document.querySelectorAll('.mobile-menu__links > ul > li > div')
    const mobileLinkContent = document.querySelectorAll('.mobile-menu__links > ul > li > ul')

    accordion(mobileLink, mobileLinkContent, mobileLink);

    hero();

    // playVideo(heroPlayBtn, heroVideo);

    // playVideo(byNumbersPlayBtn, byNumbersVideo);

    tabs(solutionsButtons, solutionsTabs);

    accordion(servicesFaqBtns, servicesFaqCont, servicesFaqItems);

    accordion(faqBlockBtns, faqBlockCont, faqBlockItems);


    tabs(careersButtons, careersTabs)

    contactForm();

    reviews();

    postVideo();

    header();

    customSelect();

    GatedContentForm();

    servicesFaq();

    popupVideo()
});
